__turbopack_context__.v({
  "profile_icon": "kwn9Tq_profile_icon",
  "profile_initial_thumbnail": "kwn9Tq_profile_initial_thumbnail",
  "profile_passport_compass": "kwn9Tq_profile_passport_compass",
  "user": "kwn9Tq_user",
});
